import { InjectionToken } from '@angular/core';

export const SidenavLinksProvider = new InjectionToken('Sidenav Links Array');

